import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import RegisterWithInvitation from './pages/RegisterWithInvitation';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Lesson from './pages/Lesson';
import LearningHistory from './pages/LearningHistory';
import TestPage from './pages/TestPage';
import TestSubtitle from './pages/TestSubtitle';
import AdminLogin from './pages/AdminLogin';
import AdminUpload from './pages/AdminUpload';
import AdminManage from './pages/AdminManage';
import AdminVocabulary from './pages/AdminVocabulary';
import AdminInvitation from './pages/AdminInvitation';
import AdminUsers from './pages/AdminUsers';
import EnglishCards from './pages/EnglishCards';
import VideoLibrary from './pages/VideoLibrary';
import AudioLibrary from './pages/AudioLibrary';
import LearningStatistics from './pages/LearningStatistics';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>加载中...</div>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>加载中...</div>;
  }
  
  if (user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

const AppRoutes = () => {
  return (
    <>
      {/* 导航栏已在Home页面集成，这里不显示 */}
      <main className="main-content" style={{ paddingTop: 0 }}>
        <Routes>
          {/* 公共路由 - 未登录用户可以访问 */}
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/register/:code" element={<PublicRoute><RegisterWithInvitation /></PublicRoute>} />
          
          {/* 受保护的路由 - 需要登录才能访问 */}
          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/courses" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
          <Route path="/courses/:id" element={<ProtectedRoute><CourseDetail /></ProtectedRoute>} />
          <Route path="/lesson/:courseId/:lessonId" element={<ProtectedRoute><Lesson /></ProtectedRoute>} />
          <Route path="/lesson/:id" element={<ProtectedRoute><Lesson /></ProtectedRoute>} />
          <Route path="/learning-history" element={<ProtectedRoute><LearningHistory /></ProtectedRoute>} />
          <Route path="/video-library" element={<ProtectedRoute><VideoLibrary /></ProtectedRoute>} />
          <Route path="/audio-library" element={<ProtectedRoute><AudioLibrary /></ProtectedRoute>} />
          <Route path="/learning-statistics" element={<ProtectedRoute><LearningStatistics /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/test-subtitle" element={<ProtectedRoute><TestSubtitle /></ProtectedRoute>} />
          <Route path="/english-cards" element={<ProtectedRoute><EnglishCards /></ProtectedRoute>} />
          
          {/* 管理员路由 */}
          <Route path="/admin" element={<Navigate to="/admin/login" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/upload" element={<AdminUpload />} />
          <Route path="/admin/manage" element={<AdminManage />} />
          <Route path="/admin/vocabulary" element={<AdminVocabulary />} />
          <Route path="/admin/vocabulary/:lessonId" element={<AdminVocabulary />} />
          <Route path="/admin/invitation" element={<AdminInvitation />} />
          <Route path="/admin/users" element={<AdminUsers />} />
        </Routes>
      </main>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
